import { render } from "./ProposalSearchList.vue?vue&type=template&id=561a4916&scoped=true"
import script from "./ProposalSearchList.vue?vue&type=script&lang=ts"
export * from "./ProposalSearchList.vue?vue&type=script&lang=ts"

import "./ProposalSearchList.vue?vue&type=style&index=0&id=561a4916&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-561a4916"

export default script